// extracted by mini-css-extract-plugin
export default {"footerContainer":"footer_footerContainer__tStv8","inner":"footer_inner__-dp6j"};